import { Alert, Button, Form, Space, Typography } from 'antd'
import AuthorisedContainer from 'components/AuthorisedContainer'
import { PermissionSetMap } from 'constants/RBACConstants'
import React, { forwardRef, useCallback, useEffect } from 'react'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { isUndefined } from 'lodash'
import {WhiteHatRiskSupportAPI } from 'restAPI/ToolsIntegrationAPI'

const WhiteHatRiskSupportSelection = forwardRef(({toolName},ref) => {
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();

    useEffect(() => {
        const {cancel,promise} = WhiteHatRiskSupportAPI.getConfiguredRiskSupport();
        promise.then((resData)=>{
            if (!isUndefined(resData)) {
                form.setFieldsValue(resData?.config)
            }
        });
        return cancel;
    }, [globalFilterHash,form])

    const fields = [{
        name: "method",
        type: FieldTypes.RADIO,
        permission:PermissionSetMap.UPDATE_SLA,
        required:true,
        options:[
            {
                label:"WhiteHat Advanced",
                value:"Advanced"
            },
            {
                label:"WhiteHat Legacy",
                value:"Legacy"
            },
        ]
    }]


    const onReset = useCallback(async() => {
            form.setFieldsValue({method:"Legacy"});
      },[form,]);



    return (
        <Space direction="vertical" className="m-b-m">
            <Typography.Text>Select the {toolName} Rating Method</Typography.Text>
            <Alert 
                description={
                    <Form 
                        form={form}
                        ref={ref}
                        style={{minWidth:400}} 
                        layout="vertical"
                    >
                        {generateFormFields(fields)}

                        <Form.Item className="text-right p-x-sm" >
                            <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                                <Button type="primary" onClick={onReset}>Reset</Button>
                            </AuthorisedContainer>
                         </Form.Item>    
                    </Form>
                } 
            />
        </Space>
    )
})

export default WhiteHatRiskSupportSelection
